import http from '../../../axios'

// 重设密码
export let resetPassword = (params = '') =>
  http.post('/user/reset-pw ', params)